/** @format */

import {
  Row,
  Col,
  Cascader,
  Spin,
  Empty,
  Progress,
  Calendar,
  Skeleton,
  Tooltip,
  Avatar,
  Form,
  FormProps,
  Switch,
  DatePicker,
} from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { BaseColor } from "../../../theme/maps/Colors";
import { UICard } from "../../ui/Card";
import { UITitle } from "../../ui/Title";
import UITransition from "../../ui/Transition";
import moment from "moment";
import { CustomRangePicker } from "../../layout/SideDialogs/RequestCreate";
import { API_ENDPOINTS } from "../../../constants/api";
import apiClient from "../../../utils/apiClient";
import { TUser } from "../../../redux-modules/declarations/maps/auth";
import {
  CheckOutlined,
  CloseOutlined,
  ContainerOutlined,
  DeliveredProcedureOutlined,
  EyeOutlined,
  FileExcelOutlined,
  InfoCircleFilled,
  LeftCircleOutlined,
  LeftOutlined,
  LoadingOutlined,
  PrinterOutlined,
  RightCircleOutlined,
  SearchOutlined,
  SettingOutlined,
  SwapOutlined,
  WindowsOutlined,
} from "@ant-design/icons";
import { UIButton } from "../../ui/Button";
import styled from "styled-components";
import { TJustificativeType, TPresenceExportType } from "../../../redux-modules/declarations/maps/presences";
import {
  UserRow,
  ReportViewOptionsProvider,
  ReportLegend,
  ReportPeriodInfo,
  getPeriodFromReport,
  countAnomalyDays,
} from "./partials/UserRow";
import { ReportScrollProvider, ReportScrollNav } from "./partials/ReportScrollSync";
import { ReportFilters, ReportEmptyResult } from "./partials/ReportFilters";
import { useHistory } from "react-router";
import { useReactToPrint } from "react-to-print";
import LazyList from "lazylist-react";
import { showNotification, showNotificationWithButton } from "../../../utils/showNotification";
import { apiReportPResencesStatus } from "../../../api/apiPresences";
import { sleep } from "../../../utils/sleep";
import { ShiftStatistics } from "./partials/ShiftStatistics";
import { PresenceStatistics } from "./partials/PresenceStatistics";
import { UIDatePicker } from "../../ui/DatePicker";
import { UIInput } from "../../ui/Input";
import { useDebouncedInput } from "../../../redux-modules/hooks/useDebouncedInput";
import { useDispatch, useSelector } from "react-redux";
import { actionCollapseRequest } from "../../../redux-modules/actions/actionsUI";
import { selectorPermissionList } from "../../../redux-modules/selectors/selectorsPermissions";
import { hasPermission } from "../../../utils/permissions/hasPermission";
import { MissingUsersModal } from "../../layout/SideDialogs/ReportMissingUsers";
import { UISelect } from "../../ui/Select";
import UIModal from "../../ui/Modal";
import { CustomCalendar } from "../../layout/Widgets/CreateRequest/partials/MyRequestsCalendar";
import { UICheckbox } from "../../ui/Checkbox";
import { selectorLocationsList } from "../../../redux-modules/selectors/selectorsLocations";
import { UIText } from "../../ui/Text";
import { RequestStatistics } from "./partials/RequestStatistics";
import { selectorJustificativeList } from "../../../redux-modules/selectors/selectorsJustificatives";

interface Option {
  value: string | number;
  label: string;
  children?: Option[];
}

export interface THoliday {
  id: string;
  description: string;
  date: string;
  ricorsivo: boolean;
  offices: string[];
}

export type ReportCellValue = string | number;

export interface ReportData {
  user: TUser;
  totals: { [k: string]: ReportCellValue };
  date: { [k: string]: { [k: string]: ReportCellValue } };
  group_name?: string;
  user_id?: string | number;
  surname?: string;
}

export const ViewReportPresences = (): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [dateFrom, setDateFrom] = useState(moment().startOf("month"));
  const [dateTo, setDateTo] = useState(moment().endOf("month"));
  const [dateFromProd, setDateFromProd] = useState(moment().startOf("month"));
  const [dateToProd, setDateToProd] = useState(moment().endOf("month"));

  const [dateFromAnomalie, setDateFromAnomalie] = useState(moment().startOf("month"));
  const [dateToAnomalie, setDateToAnomalie] = useState(moment().endOf("month"));

  const [dateFromFerie, setDateFromFerie] = useState(moment().startOf("month"));
  const [dateToFerie, setDateToFerie] = useState(moment().endOf("month"));

  const [dateFromMalattie, setDateFromMalattie] = useState(moment().startOf("month"));
  const [dateToMalattie, setDateToMalattie] = useState(moment().endOf("month"));

  const [dateFromReportGiustificativi, setDateFromReportGiustificativi] = useState(moment().startOf("month"));
  const [dateToReportGiustificativi, setDateToReportGiustificativi] = useState(moment().endOf("month"));

  const [debouncedQuery, currentQuery, setQuery] = useDebouncedInput("", () => true, false, 600);

  const [percentage, setPercentage] = useState<string | undefined>();
  const [percentageProd, setPercentageProd] = useState<string | undefined>();
  const [userList, setUserList] = useState<TUser[]>([]);
  const [userListWithDisabled, setuserListWithDisabled] = useState<TUser[]>([]);
  const [options, setOptions] = useState<Option[]>([]);
  const [optionsUsersWithDisabled, setOptionsUsersWithDisabled] = useState<Option[]>([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedValuesProd, setSelectedValuesProd] = useState([]);
  const [selectedValuesAnomalie, setSelectedValuesAnomalie] = useState([]);
  const [selectedValuesFerie, setSelectedValuesFerie] = useState([]);
  const [selectedValuesMalattie, setSelectedValuesMalattie] = useState([]);
  const [selectedValuesReportGiustificativi, setSelectedValuesReportGiustificativi] = useState([]);
  const [reportData, setReportData] = useState<{ [k: string]: ReportData }>();
  const [reportDataFiltered, setReportDataFiltered] = useState<ReportData[]>();
  const [isShowLoading, setIsShowLoading] = useState(false);
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [isCSVLoading, setIsCSVLoading] = useState(false);
  const [isXlsLoading, setIsXlsLoading] = useState(false);
  const [isXlsProdLoading, setIsXlsProdLoading] = useState(false);
  const [isCSVProdLoading, setIsCSVProdLoading] = useState(false);
  const [isTeamSystemLoading, setIsTeamSystemLoading] = useState(false);
  const [isZucchettiLoading, setIsZucchettiLoading] = useState(false);
  const [isJOBLoading, setIsJOBLoading] = useState(false);
  const [isAnomalieLoading, setIsAnomalieLoading] = useState(false);
  const [isFerieLoading, setIsFerieLoading] = useState(false);
  const [isMalattieLoading, setIsMalattieLoading] = useState(false);
  const [isReportGiustificativiLoading, setIsReportGiustificativiLoading] = useState(false);
  const [isQueryLoading, setIsQueryLoading] = useState(false);
  const [utentiMancanti, setUtentiMancanti] = useState<string[]>([]);
  const [showUtentiMancantiModal, setShowUtentiMancantiModal] = useState(false);
  const permissionList = useSelector(selectorPermissionList);
  const canExportTS = hasPermission(permissionList, "Report", "Teamsystem");
  const canExportProd = hasPermission(permissionList, "Report", "Produttivita");
  const canExportZucchetti = hasPermission(permissionList, "Report", "Zucchetti");
  const canExportJOB = hasPermission(permissionList, "Report", "JOB");
  const canViewAnalytics = hasPermission(permissionList, "Report", "Analitiche");
  const canViewPresenze = hasPermission(permissionList, "Report", "Presenze");
  const canViewAnomalie = hasPermission(permissionList, "Report", "Anomalie");
  const canViewFerie = hasPermission(permissionList, "Report", "Ferie");
  const canViewMalattie = hasPermission(permissionList, "Report", "Malattie");
  const canViewReportGiustificativi = hasPermission(permissionList, "Report", "Giustificativi");
  const canViewBlockMonth = hasPermission(permissionList, "BlockMonth", "Create");
  const canViewHolidayCalendar = hasPermission(permissionList, "Holiday", "Create");
  const canExportXls = hasPermission(permissionList, "Report", "Xls");
  const canExportXlsProduttivita = hasPermission(permissionList, "Report", "Xlsproduttivita");
  const [isBlockMonthVisible, setIsBlockMonthVisible] = useState(false);
  const [blockMonths, setBlockMonths] = useState<string[]>([]);
  const [holidayCalendar, setHolidayCalendar] = useState<THoliday[]>([]);
  const [isBlockMonthLoading, setIsBlockMonthLoading] = useState(false);
  const [isHolidayCalendarLoading, setIsHolidayCalendarLoading] = useState(false);
  const [selectedHolidayCalendar, setSelectedHolidayCalendar] = useState<string | undefined>(
    undefined,
  );
  const [form] = Form.useForm();
  const offices = useSelector(selectorLocationsList);
  const justificatives = useSelector(selectorJustificativeList);
  const [justificativeTypeId, setJustificativeTypeId] = useState("")
  const { Option } = UISelect;

  const [reportMalattiaIsAnalitico, setReportMalattiaIsAnalitico] = useState(false); 
  
  const [selectedOffice, setSelectedOffice] = useState<string>();
  const [forceAnomalies, setForceAnomalies] = useState(true);
  const [filterAnomalyTimebankNotApproved, setFilterAnomalyTimebankNotApproved] = useState(false);
  const [filterAnomalyTurnoNonProgrammato, setFilterAnomalyTurnoNonProgrammato] = useState(false);
  const [filterAnomalyMancataTimbratura, setFilterAnomalyMancataTimbratura] = useState(false);
  const [filterStraordinarioIntoOrdinario, setFilterStraordinarioIntoOrdinario] = useState(false);

  const [hideEmptyRows, setHideEmptyRows] = useState(false);
  const [onlyWithAnomalies, setOnlyWithAnomalies] = useState(false);

  // Gestione Utenti Disabilitati Report Prod.
  const [checkDisabledUsers, setCheckDisabledUsers] = useState(false);
  function toggleDisabledUsers(){

  }

    const [selectedYear, setSelectedYear] = useState<moment.Moment | null>(moment());

    const handleYearChange = (date: moment.Moment | null) => {
      setSelectedYear(date);
    };

  const getFilterAnomalies = () => {
    return {
      filterAnomaly_TimebankNotApproved: forceAnomalies || filterAnomalyTimebankNotApproved,
      filterAnomaly_TurnoNonProgrammato: forceAnomalies || filterAnomalyTurnoNonProgrammato,
      filterAnomaly_MancataTimbratura: forceAnomalies || filterAnomalyMancataTimbratura,
    };
  }

  const getOfficeSelected = () => {
    if(selectedOffice){
      return {filter_office_id: selectedOffice};
    }
    return;
  }

  const getOfficeSelectedInfo = () :  JSX.Element => {
    if(!selectedOffice) return <></>;

    const location = offices.data.find(office => office.id === selectedOffice);
    if(location){
      return <Row style={{marginBottom: "16px"}}>
          <span>
            <b>Sede Selezionata: </b> 
            {location.name} &shy;
            {/*@ts-ignore*/} 
            (<i>{location.location}</i>)
          </span>
        </Row>
    }

    return <></>;
  }

  const getHolidayByDate = (
    date: string,
  ):
    | {
        id: string;
        description: string;
        date: string;
        date_from?: string;
        date_to?: string;
        ricorsivo: boolean;
        offices: string[];
      }
    | undefined => {
    const holiday = holidayCalendar.find(h => h.date == date);
    const hilday_period = holidayCalendar.filter(h => h.description == holiday?.description);
    const holiday_period_ordered = hilday_period.sort((a, b) => {
      return moment(a.date).isBefore(moment(b.date)) ? -1 : 1;
    });

    return holiday
      ? hilday_period.length > 1
        ? {
            ...holiday,
            date_from: holiday_period_ordered[0].date,
            date_to: holiday_period_ordered[holiday_period_ordered.length - 1].date,
          }
        : holiday
      : undefined;
  };

  const onRemoveHoliday = (date?: string) => {
    if (date) {
      const holiday = getHolidayByDate(date);
      apiClient.delete(API_ENDPOINTS.HOLIDAY_CALENDAR + "/" + holiday?.id).then(() => {
        setSelectedHolidayCalendar(undefined);
        updateHolidayCalendar();
      });
    }
  };

  const getConfig = (date: string, action: "block" | "unblock") => {
    return UIModal.confirm({
      title: `Sei sicuro di voler ${action == "block" ? "blocc" : "sblocc"}are il mese di ${moment(
        date,
      ).format("MMMM")}?`,
      content: `Sei sicuro di voler ${
        action == "block" ? "blocc" : "sblocc"
      }are il mese di ${moment(date).format("MMMM")}?`,
      okText: "Conferma",
      cancelText: "Annulla",
      onOk: async () => {
        try {
          const res = await apiClient.post(
            action == "block" ? API_ENDPOINTS.BLOCK_MONTHS : API_ENDPOINTS.UNBLOCK_MONTHS,
            {
              date_from: moment(date).startOf("month").format("YYYY-MM-DD"),
              date_to: moment(date).endOf("month").format("YYYY-MM-DD"),
            },
          );

          //@ts-ignore
          if (!!res.data) {
            showNotification(
              "success",
              `Mese ${action == "block" ? "blocc" : "sblocc"}ato correttamente`,
              `Il mese di ${moment(date).format("MMMM")} è stato ${
                action == "block" ? "blocc" : "sblocc"
              }ato correttamente`,
            );
            updateBlockMonths();
          } else {
            showNotification(
              "error",
              //@ts-ignore
              res.message,
              "Si è verificato un errore durante il blocco del mese di " +
                moment(date).format("MMMM"),
            );
          }
        } catch (e) {
          //@ts-ignore
          showNotification("error", e.message);
        }
      },
    });
  };
  const [monthRichieste, setMonthRichieste] = useState<moment.Moment | null>(moment());
  const [monthTurni, setMonthTurni] = useState<moment.Moment | null>(moment());
  const [monthPresenze, setMonthPresenze] = useState<moment.Moment | null>(moment());

  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: "@page { size: A4 landscape; margin: 8mm; }",
  });

  // Periodo effettivamente restituito dal backend (non dipende dal RangePicker)
  const reportPeriod = useMemo(() => getPeriodFromReport(reportData), [reportData]);

  // Dipendenti con almeno un giorno in anomalia: calcolato una volta per report
  const usersWithAnomalies = useMemo(
    () =>
      new Set(
        Object.values(reportData || {})
          .filter(el => countAnomalyDays(el) > 0)
          .map(el => el.user.id),
      ),
    [reportData],
  );

  const changeDates = (dates: moment.Moment[]) => {
    setDateFrom(dates[0]);
    setDateTo(dates[1]);
  };

  const changeDatesProd = (dates: moment.Moment[]) => {
    setDateFromProd(dates[0]);
    setDateToProd(dates[1]);
  };

  const changeDatesAnomalie = (dates: moment.Moment[]) => {
    setDateFromAnomalie(dates[0]);
    setDateToAnomalie(dates[1]);
  };
  const changeDatesFerie = (dates: moment.Moment[]) => {
    setDateFromFerie(dates[0]);
    setDateToFerie(dates[1]);
  };
  const changeDatesMalattie = (dates: moment.Moment[]) => {
    setDateFromMalattie(dates[0]);
    setDateToMalattie(dates[1]);
  };

  const changeDatesReportGiustificativi = (dates: moment.Moment[]) => {
    setDateFromReportGiustificativi(dates[0]);
    setDateToReportGiustificativi(dates[1]);
  };

  useEffect(() => {
    setIsUserLoading(true);
    apiClient.get(API_ENDPOINTS.USERS_LIST + "?all=true").then(res => {
      setUserList(res.data.data);
      setIsUserLoading(false);
    });

    setIsUserLoading(true);
    apiClient.get(API_ENDPOINTS.USERS_LIST + "?all=true&with_disabled=true").then(res => {
      setuserListWithDisabled(res.data.data);
      setIsUserLoading(false);
    });

    updateBlockMonths();
    updateHolidayCalendar();
  }, []);

  const updateBlockMonths = () => {
    setIsBlockMonthLoading(true);
    apiClient.get(API_ENDPOINTS.BLOCK_MONTHS).then(res => {
      setBlockMonths(res.data);
      setIsBlockMonthLoading(false);
    });
  };

  const updateHolidayCalendar = () => {
    setIsHolidayCalendarLoading(true);
    apiClient.get(API_ENDPOINTS.HOLIDAY_CALENDAR).then(res => {
      setHolidayCalendar(res.data);
      setIsHolidayCalendarLoading(false);
    });
  };

  useEffect(() => {
    if (!!utentiMancanti.length) {
      setShowUtentiMancantiModal(true);
    } else {
      setShowUtentiMancantiModal(false);
    }
  }, [utentiMancanti]);

  useEffect(() => {
    if (!reportData) return;
    dispatch(actionCollapseRequest());

    const query = (debouncedQuery || "").toLowerCase();

    setReportDataFiltered(
      Object.values(reportData).filter(el => {
        if (onlyWithAnomalies && !usersWithAnomalies.has(el.user.id)) return false;
        if (!query) return true;
        return JSON.stringify({ name: el.user.name, surname: el.user.surname })
          .toLowerCase()
          .includes(query);
      }),
    );
  }, [debouncedQuery, reportData, onlyWithAnomalies, usersWithAnomalies]);

  useEffect(() => {
    if (currentQuery != debouncedQuery) {
      setIsQueryLoading(true);
    } else {
      setIsQueryLoading(false);
    }
  }, [currentQuery, debouncedQuery]);

  useEffect(() => {
    if (userList) {
      let options: Option[] = populateOptions(userList);
      setOptions(options);
    }
  }, [userList]);

  useEffect(() => {
    if (userListWithDisabled) {
      let helper = []

      if(checkDisabledUsers){
        helper = userListWithDisabled
      }else{
        helper = userListWithDisabled.filter(user => user.is_disabled == false)
      }
      
      setSelectedValuesProd([])
      let options: Option[] = populateOptions(helper);
      setOptionsUsersWithDisabled(options);
    }
  }, [userListWithDisabled, checkDisabledUsers]);

  function populateOptions(list: TUser[]){
    let options: Option[] = [];
    list.forEach(user => {
        //controllo se esiste già il gruppo
        user.groups.forEach(group => {
          if (options.find(el => el.value == "group_" + group.id)) {
            if (
              options
                .find(el => el.value == "group_" + group.id)
                ?.children?.find(e => e.value == "department_" + user.department.id)
            ) {
              options
                .find(el => el.value == "group_" + group.id)
                ?.children?.find(e => e.value == "department_" + user.department.id)
                ?.children?.push({
                  value: user.id,
                  label: user.surname + " " + user.name,
                }) || console.log("");
            } else {
              options
                .find(el => el.value == "group_" + group.id)
                ?.children?.push({
                  value: "department_" + user.department.id,
                  label: group.name + " - " + user.department.name,
                  children: [
                    {
                      value: user.id,
                      label: user.surname + " " + user.name,
                    },
                  ],
                }) || console.log("");
            }
          } else {
            options.push({
              value: "group_" + group.id,
              label: group.name,
              children: [
                {
                  value: "department_" + user.department.id,
                  label: group.name + " - " + user.department.name,
                  children: [{ value: user.id, label: user.surname + " " + user.name }],
                },
              ],
            });
          }
        });
      });

      return options;
  }

  const onChangeFilters = (value: unknown) => {
    //@ts-ignore
    setSelectedValues(value);
  };

  const onChangeFiltersProd = (value: unknown) => {
    //@ts-ignore
    setSelectedValuesProd(value);
  };

  const onChangeFiltersAnomalie = (value: unknown) => {
    //@ts-ignore
    setSelectedValuesAnomalie(value);
  };
  const onChangeFiltersFerie = (value: unknown) => {
    //@ts-ignore
    setSelectedValuesFerie(value);
  };
  const onChangeFiltersMalattie = (value: unknown) => {
    //@ts-ignore
    setSelectedValuesMalattie(value);
  };

  const onChangeFiltersReportGiustificativi = (value: unknown) => {
    //@ts-ignore
    setSelectedValuesReportGiustificativi(value);
  };

  const onChangeJustificativeTypeId = (value: unknown) =>{
    console.log(value);
    setJustificativeTypeId(value as string)
  }

  const getUsersArray = (array: string[], isReportProduttivita: boolean = false): string[] => {
    let users: string[] = [];
    let usersListHelper = isReportProduttivita ? userListWithDisabled : userList;
    
    if (array.length > 0) {
      array.forEach((value: string) => {
        // se gruppo
        if (value.length == 1) {
          let gruppo = value[0].split("_")[1];
          usersListHelper.forEach(user => {
            if (user.groups.find(group => group.id == gruppo)) {
              users.push(user.id);
            }
          });
        }
        // se dipartimento
        else if (value.length == 2) {
          let gruppo = value[0].split("_")[1];
          let dipartimento = value[1].split("_")[1];
          usersListHelper.forEach(user => {
            if (
              user.groups.find(group => group.id == gruppo) &&
              user.department.id == dipartimento
            ) {
              users.push(user.id);
            }
          });
        }
        // se utente
        else if (value.length == 3) {
          users.push(value[2]);
        }
      });
    } else {
      users = usersListHelper.map(user => user.id);
    }

    return users;
  };

  const exportPlain = () => {
    setIsShowLoading(true);
    const users = getUsersArray(selectedValues);
    let stillPolling = true;

    apiClient
      .get(API_ENDPOINTS.REPORT_PRESENCES_START)
      .then(async r => {
        apiClient
          .post(process.env.REACT_APP_API_URL + "/export_payslip", {
            user_ids: users,
            date_from: dateFrom.format("YYYY-MM-DD"),
            date_to: dateTo.format("YYYY-MM-DD"),
            export_type_id: TPresenceExportType.PLAIN,
            temp_id: r.data.id,
            ...getFilterAnomalies(),
            ...getOfficeSelected(),
            filterStraordinarioIntoOrdinario: filterStraordinarioIntoOrdinario 
          })
          .then(res => {
            stillPolling = false;
            setPercentage(undefined);
            setReportDataFiltered(Object.values(res.data));
            setReportData(res.data);
            setIsShowLoading(false);
          })
          .catch(err => {
            stillPolling = false;
            setPercentage(undefined);
            setIsShowLoading(false);
            showNotification("error", "Oops..", "Errore durante la generazione del report");
          });

        //VA IN POLLINGO
        let counter = 0;
        const id = r.data.id;
        while (stillPolling) {
          apiReportPResencesStatus(id)
            .then(res => {
              //@ts-ignore
              if (res.data.status === "completed") {
                stillPolling = false;
                setPercentage(undefined);
              } else {
                //@ts-ignore
                setPercentage(res.data.msg);
              }
            })
            .catch(e => {
              stillPolling = false;
              setPercentage(undefined);
              setIsShowLoading(false);
              showNotification("error", "Oops..", "Errore durante la generazione del report");
            });

          if (counter > 90) {
            stillPolling = false;
            setPercentage(undefined);
          }

          counter++;
          await sleep(2000);
        }
      })
      .catch(e => {
        setPercentage(undefined);
        setIsShowLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportCsv = () => {
    setIsCSVLoading(true);
    const users = getUsersArray(selectedValues);

    apiClient
      .get(API_ENDPOINTS.REPORT_PRESENCES_START)
      .then(async r => {
        apiClient
          .post(process.env.REACT_APP_API_URL + "/export_payslip", {
            user_ids: users,
            date_from: dateFrom.format("YYYY-MM-DD"),
            date_to: dateTo.format("YYYY-MM-DD"),
            export_type_id: TPresenceExportType.CSV,
            temp_id: r.data.id,
            ...getFilterAnomalies(),
            ...getOfficeSelected(),
            filterStraordinarioIntoOrdinario: filterStraordinarioIntoOrdinario 
          })
          .then(res => {
            setIsCSVLoading(false);
            showNotification("success", "Report", res.data.success, 8);
          })
          .catch(err => {
            setIsCSVLoading(false);
            showNotification("error", "Oops..", "Errore durante la generazione del report");
          });
      })
      .catch(e => {
        setIsShowLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportXls = () => {
    setIsXlsLoading(true);
    const users = getUsersArray(selectedValues);

    apiClient
      .get(API_ENDPOINTS.REPORT_PRESENCES_START)
      .then(async r => {
        apiClient
          .post(process.env.REACT_APP_API_URL + "/export_payslip", {
            user_ids: users,
            date_from: dateFrom.format("YYYY-MM-DD"),
            date_to: dateTo.format("YYYY-MM-DD"),
            export_type_id: TPresenceExportType.XLS,
            temp_id: r.data.id,
            ...getFilterAnomalies(),
            ...getOfficeSelected(),
            filterStraordinarioIntoOrdinario: filterStraordinarioIntoOrdinario 
          })
          .then(res => {
            setIsXlsLoading(false);
            showNotification("success", "Report", res.data.success, 8);
          })
          .catch(err => {
            setIsXlsLoading(false);
            showNotification("error", "Oops..", "Errore durante la generazione del report");
          });
      })
      .catch(e => {
        setIsShowLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportCsvWithCache = () => {
    setIsCSVLoading(true);
    const users = getUsersArray(selectedValues);
    apiClient
      .post(process.env.REACT_APP_API_URL + "/export_payslip", {
        user_ids: users,
        date_from: dateFrom.format("YYYY-MM-DD"),
        date_to: dateTo.format("YYYY-MM-DD"),
        export_type_id: TPresenceExportType.CSV_WITH_CACHE,
      })
      .then(res => {
        setIsCSVLoading(false);
        window.open(res.data.url, "_blank");
      })
      .catch(err => {
        setIsCSVLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportTeamSystemWithCache = () => {
    setIsTeamSystemLoading(true);
    const users = getUsersArray(selectedValues);
    apiClient
      .post(process.env.REACT_APP_API_URL + "/export_payslip", {
        user_ids: users,
        date_from: dateFrom.format("YYYY-MM-DD"),
        date_to: dateTo.format("YYYY-MM-DD"),
        export_type_id: TPresenceExportType.TEAMSYSTEM_WITH_CACHE,
      })
      .then(res => {
        setIsTeamSystemLoading(false);
        window.open(res.data.url, "_blank");
      })
      .catch(err => {
        setIsTeamSystemLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportZucchettiWithCache = () => {
    setIsZucchettiLoading(true);
    const users = getUsersArray(selectedValues);
    apiClient
      .post(process.env.REACT_APP_API_URL + "/export_payslip", {
        user_ids: users,
        date_from: dateFrom.format("YYYY-MM-DD"),
        date_to: dateTo.format("YYYY-MM-DD"),
        export_type_id: TPresenceExportType.ZUCCHETTI_WITH_CACHE,
      })
      .then(res => {
        setIsZucchettiLoading(false);
        window.open(res.data.url, "_blank");
      })
      .catch(err => {
        setIsZucchettiLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportCsvProd = () => {
    setIsCSVProdLoading(true);
    const users = getUsersArray(selectedValuesProd, true);

    apiClient
      .get(API_ENDPOINTS.REPORT_PRESENCES_START)
      .then(async r => {
        apiClient
          .post(process.env.REACT_APP_API_URL + "/export_payslip", {
            user_ids: users,
            date_from: dateFromProd.format("YYYY-MM-DD"),
            date_to: dateToProd.format("YYYY-MM-DD"),
            export_type_id: TPresenceExportType.PRODUTTIVITA,
            temp_id: r.data.id,
          })
          .then(res => {
            setIsCSVProdLoading(false);
            showNotification("success", "Report", res.data.success, 8);
          })
          .catch(err => {
            setIsCSVProdLoading(false);
            showNotification("error", "Oops..", "Errore durante la generazione del report");
          });
      })
      .catch(e => {
        setIsShowLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportXlsProd = () => {
    setIsXlsProdLoading(true);
    const users = getUsersArray(selectedValuesProd, true);

    apiClient
      .get(API_ENDPOINTS.REPORT_PRESENCES_START)
      .then(async r => {
        apiClient
          .post(process.env.REACT_APP_API_URL + "/export_payslip", {
            user_ids: users,
            date_from: dateFromProd.format("YYYY-MM-DD"),
            date_to: dateToProd.format("YYYY-MM-DD"),
            export_type_id: TPresenceExportType.XLS_PRODUTTIVITA,
            temp_id: r.data.id,
          })
          .then(res => {
            setIsXlsProdLoading(false);
            showNotification("success", "Report", res.data.success, 8);
          })
          .catch(err => {
            setIsXlsProdLoading(false);
            showNotification("error", "Oops..", "Errore durante la generazione del report");
          });
      })
      .catch(e => {
        setIsShowLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportTeamSystem = async () => {
    setIsTeamSystemLoading(true);
    const users = getUsersArray(selectedValues);

    try {
      const responsePresencesStart = await apiClient.get(API_ENDPOINTS.REPORT_PRESENCES_START);
      if (responsePresencesStart.status === 201) {
        try{
          const responseTS = await apiClient.post(process.env.REACT_APP_API_URL + "/export_payslip", {
            user_ids: users,
            date_from: dateFrom.format("YYYY-MM-DD"),
            date_to: dateTo.format("YYYY-MM-DD"),
            export_type_id: TPresenceExportType.TEAMSYSTEM,
            temp_id: responsePresencesStart.data.id,
            ...getFilterAnomalies(),
            ...getOfficeSelected(),
            filterStraordinarioIntoOrdinario: filterStraordinarioIntoOrdinario 
          }); 

          if(responseTS.status == 200){
            setIsTeamSystemLoading(false);
            showNotification("success", "Report", responseTS.data.success, 8);
          }
        }catch(error){
          setIsTeamSystemLoading(false);
          let errorToShow : string | React.ReactNode = ""
          //@ts-ignore
          if (error.response && error.response.status === 400) {
            //@ts-ignore
            if(!!error.response.data){
              //@ts-ignore
              const msg = error.response.data.message
              //@ts-ignore
              const errors = error.response.data.errors
              
              errorToShow = (
                <div style={{ maxHeight: 200, overflowY: "auto" }}>
                  {msg}<br/><br/>
                  {
                    <ul style={{ paddingLeft: "20px", margin: 0 }}>
                      {
                        //@ts-ignore
                        errors.map((err, i) => (
                          <li key={i} style={{ marginBottom: "4px" }}>
                            {err}
                          </li>
                      ))}
                    </ul>
                  }
                </div>
              )
            }
            showNotificationWithButton("error", "Errore", errorToShow)
          } else {
            showNotification("error", "Oops..", "Errore durante la generazione del report");
          }
        }
      } else {
        setIsTeamSystemLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      }
    } catch (error) {
      setIsTeamSystemLoading(false);
      showNotification("error", "Oops..", "Errore durante la generazione del report");
    }

   /* apiClient
      .get(API_ENDPOINTS.REPORT_PRESENCES_START)
      .then(async r => {

        const responseTS = await apiClient.post(process.env.REACT_APP_API_URL + "/export_payslip", {
            user_ids: users,
            date_from: dateFrom.format("YYYY-MM-DD"),
            date_to: dateTo.format("YYYY-MM-DD"),
            export_type_id: TPresenceExportType.TEAMSYSTEM,
            temp_id: r.data.id,
            ...getFilterAnomalies(),
            ...getOfficeSelected(),
            filterStraordinarioIntoOrdinario: filterStraordinarioIntoOrdinario 
          });

          if(!!responseTS.data){
            setIsTeamSystemLoading(false);
            showNotification("success", "Report", responseTS.data.success, 8);
          }else{
            setIsTeamSystemLoading(false);
            //@ts-ignore
            showNotification("error", "Oops..",responseTS.message);
          }

        apiClient
          .post(process.env.REACT_APP_API_URL + "/export_payslip", {
            user_ids: users,
            date_from: dateFrom.format("YYYY-MM-DD"),
            date_to: dateTo.format("YYYY-MM-DD"),
            export_type_id: TPresenceExportType.TEAMSYSTEM,
            temp_id: r.data.id,
            ...getFilterAnomalies(),
            ...getOfficeSelected(),
            filterStraordinarioIntoOrdinario: filterStraordinarioIntoOrdinario 
          })
          .then(res => {
            setIsTeamSystemLoading(false);
            showNotification("success", "Report", res.data.success, 8);
          })
          .catch(err => {
            console.log("TS: " +err)
            setIsTeamSystemLoading(false);
            showNotification("error", "Oops..", "Errore durante la generazione del report");
          });
      })
      .catch(e => {
        setIsShowLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });*/
  };

  const exportZucchetti = () => {
    setIsZucchettiLoading(true);
    const users = getUsersArray(selectedValues);

    apiClient
      .get(API_ENDPOINTS.REPORT_PRESENCES_START)
      .then(async r => {
        apiClient
          .post(process.env.REACT_APP_API_URL + "/export_payslip", {
            user_ids: users,
            date_from: dateFrom.format("YYYY-MM-DD"),
            date_to: dateTo.format("YYYY-MM-DD"),
            export_type_id: TPresenceExportType.ZUCCHETTI,
            temp_id: r.data.id,
            ...getFilterAnomalies(),
            ...getOfficeSelected(),
            filterStraordinarioIntoOrdinario: filterStraordinarioIntoOrdinario 
          })
          .then(res => {
            setIsZucchettiLoading(false);
            showNotification("success", "Report", res.data.success, 8);
          })
          .catch(err => {
            setIsZucchettiLoading(false);
            showNotification("error", "Oops..", "Errore durante la generazione del report");
          });
      })
      .catch(e => {
        setIsShowLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportJOB = () => {
    setIsJOBLoading(true);
    const users = getUsersArray(selectedValues);
    let stillPolling = true;

    apiClient
      .get(API_ENDPOINTS.REPORT_PRESENCES_START)
      .then(async r => {
        apiClient
          .post(process.env.REACT_APP_API_URL + "/export_payslip", {
            user_ids: users,
            date_from: dateFrom.format("YYYY-MM-DD"),
            date_to: dateTo.format("YYYY-MM-DD"),
            export_type_id: TPresenceExportType.JOB,
            temp_id: r.data.id,
          })
          .then(res => {
            stillPolling = false;
            setPercentage(undefined);
            setIsJOBLoading(false);
            if (res.data.utenti_mancanti.length > 0) {
              setUtentiMancanti(res.data.utenti_mancanti);
            }
            window.open(res.data.url, "_blank");
          })
          .catch(err => {
            setPercentage(undefined);
            stillPolling = false;
            setIsJOBLoading(false);
            showNotification("error", "Oops..", "Errore durante la generazione del report");
          });

        //VA IN POLLINGO
        let counter = 0;
        const id = r.data.id;
        while (stillPolling) {
          apiReportPResencesStatus(id)
            .then(res => {
              //@ts-ignore
              if (res.data.status === "completed") {
                stillPolling = false;
                setPercentage(undefined);
              } else {
                //@ts-ignore
                setPercentage(res.data.msg);
              }
            })
            .catch(e => {
              setPercentage(undefined);
              stillPolling = false;
              setIsJOBLoading(false);
              showNotification("error", "Oops..", "Errore durante la generazione del report");
            });

          if (counter > 90) {
            stillPolling = false;
            setPercentage(undefined);
          }

          counter++;
          await sleep(2000);
        }
      })
      .catch(e => {
        setPercentage(undefined);
        stillPolling = false;
        setIsShowLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  }

  async function exportFerieAnnuale(year?: number){
    setIsReportGiustificativiLoading(true);
    try{
      if(!year){
        showNotification("error", "Oops..", "Selezionare un Anno.");
        return
      }
    
      const response = await apiClient.post(API_ENDPOINTS.REPORT_FERIE_ANNUALE, {year: year});
      if(response.status == 200){
        showNotification("success", "Report", response.data.message, 10);
      }
    }catch(err){
      // Caso in cui err ha la response della chiamata perché l'api non ha restituito 200
      // @ts-ignore 
      if(err.response){
        // @ts-ignore
        const response: AxiosResponse = err.response;

        if(response.data){
          const info = response.data;
          showNotification("error", "Oops..", info.message);
        }

      }else{
        showNotification("error", "Oops..", "Si è verificato un imprevisto, riprovare.");
      }
    }finally{
      setIsReportGiustificativiLoading(false);
    }
  }

  const goBack = () => {
    // un nuovo report non deve partire già filtrato
    setOnlyWithAnomalies(false);
    setReportData(undefined);
  };

  const handleSaveHolidays = async (values: FormProps) => {
    setIsHolidayCalendarLoading(true);
    const obj = {
      ...values,
      //@ts-ignore
      date_from: values.date[0].format("YYYY-MM-DD"),
      //@ts-ignore
      date_to: values.date[1].format("YYYY-MM-DD"),
      //@ts-ignore
      office_ids: values.office_ids.some(o => o === "all") ? [] : values.office_ids,
    };
    console.log(obj);
    apiClient
      .post(API_ENDPOINTS.HOLIDAY_CALENDAR, obj)
      .then(res => {
        showNotification("success", "Successo", "Nuova festività creata con successo");
        form.resetFields();
        setIsHolidayCalendarLoading(false);
        updateHolidayCalendar();
      })
      .catch(err => {
        showNotification("error", "Oops..", err.response.data.message);
        setIsHolidayCalendarLoading(false);
      });
  };

  const exportAnomalie = () => {
    setIsAnomalieLoading(true);
    const users = getUsersArray(selectedValuesAnomalie);
    apiClient
      .post(
        process.env.REACT_APP_API_URL + "/export_payslip",
        {
          user_ids: users,
          date_from: dateFromAnomalie.format("YYYY-MM-DD"),
          date_to: dateToAnomalie.format("YYYY-MM-DD"),
          export_type_id: TPresenceExportType.ANOMALIE,
        },
        {
          responseType: "blob",
        },
      )
      .then(res => {
        setIsAnomalieLoading(false);
        //@ts-ignore
        const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("target", "_blank");
        link.setAttribute(
          "download",
          "Export Anomalie " +
            `${dateFromAnomalie.format("YYYY-MM-DD")}` +
            " - " +
            `${dateToAnomalie.format("YYYY-MM-DD")}` +
            ".pdf",
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        setIsAnomalieLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportFerie = () => {
    setIsFerieLoading(true);
    const users = getUsersArray(selectedValuesFerie);
    apiClient
      .post(
        process.env.REACT_APP_API_URL + "/export_payslip",
        {
          user_ids: users,
          date_from: dateFromFerie.format("YYYY-MM-DD"),
          date_to: dateToFerie.format("YYYY-MM-DD"),
          export_type_id: TPresenceExportType.FERIE,
        },
        {
          responseType: "blob",
        },
      )
      .then(res => {
        setIsFerieLoading(false);
        //@ts-ignore
        const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("target", "_blank");
        link.setAttribute(
          "download",
          "Export Ferie " +
            `${dateFromFerie.format("YYYY-MM-DD")}` +
            " - " +
            `${dateToFerie.format("YYYY-MM-DD")}` +
            ".pdf",
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        setIsFerieLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportMalattie = () => {
    setIsMalattieLoading(true);
    const users = getUsersArray(selectedValuesMalattie);
    apiClient
      .post(
        process.env.REACT_APP_API_URL + "/export_payslip",
        {
          user_ids: users,
          date_from: dateFromMalattie.format("YYYY-MM-DD"),
          date_to: dateToMalattie.format("YYYY-MM-DD"),
          export_type_id: TPresenceExportType.MALATTIA,
        },
        {
          responseType: "blob",
        },
      )
      .then(res => {
        setIsMalattieLoading(false);

        //@ts-ignore
        const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("target", "_blank");
        link.setAttribute(
          "download",
          "Export Malattie " +
            `${dateFromMalattie.format("YYYY-MM-DD")}` +
            " - " +
            `${dateToMalattie.format("YYYY-MM-DD")}` +
            ".pdf",
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        setIsMalattieLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  const exportReportGiustificativi = () => {
    console.log(justificativeTypeId);
    if(justificativeTypeId === "" || justificativeTypeId == undefined){
      showNotification("error", "Oops..", "Selezionare un giustificativo.");
      return
    }

    // Se il report selezionato è di tipo FERIE ANNUALE 
    if(justificativeTypeId === TJustificativeType.FERIE_ANNUALE){
      exportFerieAnnuale(selectedYear?.year());
      return;
    }
    
    setIsReportGiustificativiLoading(true);
    const users = getUsersArray(selectedValuesReportGiustificativi);
    apiClient
      .post(
        process.env.REACT_APP_API_URL + "/export_payslip",
        {
          user_ids: users,
          date_from: dateFromReportGiustificativi.format("YYYY-MM-DD"),
          date_to: dateToReportGiustificativi.format("YYYY-MM-DD"),
          export_type_id: TPresenceExportType.REPORT_GIUSTIFICATIVI,
          justificative_type_id: justificativeTypeId,
          is_analitico: reportMalattiaIsAnalitico ? 1 : 0
        },
        {
          responseType: "blob",
        },
      )
      .then(res => {
        setIsReportGiustificativiLoading(false);

        //@ts-ignore
        const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("target", "_blank");
        link.setAttribute(
          "download",
          "Export Report Giustificativi " +
            `${dateFromReportGiustificativi.format("YYYY-MM-DD")}` +
            " - " +
            `${dateToReportGiustificativi.format("YYYY-MM-DD")}` +
            ".pdf",
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => {
        setIsReportGiustificativiLoading(false);
        showNotification("error", "Oops..", "Errore durante la generazione del report");
      });
  };

  return (
    <UITransition>
      <Row justify="space-between" align="middle" gutter={[16, 16]}>
        <Col style={{ display: "inline-flex", alignItems: "baseline" }}>
          <UITitle level={2} color={BaseColor} data-cy="page-title">
            Report e Analitiche
          </UITitle>
          {canViewBlockMonth && (
            <span
              style={{
                fontSize: "18px",
                color: BaseColor,
                cursor: "pointer",
                marginLeft: "10px",
                position: "relative",
                top: "-3px",
              }}
              onClick={() => setIsBlockMonthVisible(!isBlockMonthVisible)}
            >
              <SettingOutlined />
            </span>
          )}
        </Col>
      </Row>
      {isBlockMonthVisible && (
        <UITransition>
          <Row gutter={[8, 8]}>
            {canViewBlockMonth && (
              <Col span={6}>
                <UICard style={{ marginBottom: "8px" }}>
                  <Row justify="space-between" style={{ marginBottom: "15px" }}>
                    <Col>
                      <UITitle color={BaseColor} level={4}>
                        Disabilita mesi
                      </UITitle>
                    </Col>
                    <Col
                      style={{ color: BaseColor, cursor: "pointer", fontSize: "15px" }}
                      onClick={() => setIsBlockMonthVisible(false)}
                    >
                      <CloseOutlined /> Chiudi
                    </Col>
                  </Row>
                  <Row justify="center">
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          borderRadius: "7px",
                        }}
                      >
                        {isBlockMonthLoading ? (
                          <div style={{ padding: "10px", width: "300px" }}>
                            <Skeleton />
                          </div>
                        ) : (
                          <CustomMonthCalendar
                            fullscreen={false}
                            headerRender={({ value, type, onChange, onTypeChange }) => {
                              const start = 0;
                              const end = 12;
                              const monthOptions = [];

                              let current = value.clone();
                              const localeData = value.localeData();
                              const months = [];
                              for (let i = 0; i < 12; i++) {
                                current = current.month(i);
                                months.push(localeData.monthsShort(current));
                              }

                              for (let i = start; i < end; i++) {
                                monthOptions.push(
                                  <UISelect.Option key={i} value={i} className="month-item">
                                    {months[i]}
                                  </UISelect.Option>,
                                );
                              }

                              const year = value.year();
                              const month = value.month();
                              const options = [];
                              for (let i = year - 10; i < year + 10; i += 1) {
                                options.push(
                                  <UISelect.Option key={i} value={i} className="year-item">
                                    {i}
                                  </UISelect.Option>,
                                );
                              }
                              return (
                                <div style={{ padding: 8, textAlign: "center" }}>
                                  <Row gutter={8} justify="center">
                                    <Col>
                                      <Row justify="center">
                                        <span
                                          className="back-arrow"
                                          onClick={() => {
                                            onChange(value.clone().subtract(1, "year"));
                                          }}
                                        >
                                          <LeftCircleOutlined />
                                        </span>
                                        <span className="year-name">
                                          {value.clone().format("YYYY")}
                                        </span>
                                        <span
                                          className="next-arrow"
                                          onClick={() => {
                                            onChange(value.clone().add(1, "year"));
                                          }}
                                        >
                                          <RightCircleOutlined />
                                        </span>
                                      </Row>
                                    </Col>
                                  </Row>
                                </div>
                              );
                            }}
                            mode="year"
                            monthFullCellRender={(date: moment.Moment) => {
                              const formattedDate = date.format("YYYY-MM-DD");
                              const isBlocked = !!blockMonths.find(e => e == formattedDate);
                              return (
                                <Tooltip
                                  title={`Il mese di ${date.format("MMMM")} è attualmente ${
                                    isBlocked ? "blo" : "sblo"
                                  }ccato`}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "80%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "7px",
                                      cursor: "pointer",
                                      border: "1px solid white",
                                      backgroundColor: isBlocked ? "#f0f0f0" : "white",
                                    }}
                                    onClick={() => {
                                      getConfig(formattedDate, isBlocked ? "unblock" : "block");
                                    }}
                                  >
                                    {date.format("MMM")}
                                  </div>
                                </Tooltip>
                              );
                            }}
                          />
                        )}
                      </div>
                    </Col>
                    <Col></Col>
                  </Row>
                </UICard>
              </Col>
            )}
            {canViewHolidayCalendar && (
              <Col span={18}>
                <UICard style={{ marginBottom: "8px" }}>
                  <Row justify="space-between" style={{ marginBottom: "15px" }}>
                    <Col>
                      <UITitle color={BaseColor} level={4}>
                        Calendario festività
                      </UITitle>
                    </Col>
                    <Col
                      style={{ color: BaseColor, cursor: "pointer", fontSize: "15px" }}
                      onClick={() => setIsBlockMonthVisible(false)}
                    >
                      <CloseOutlined /> Chiudi
                    </Col>
                  </Row>
                  <Row gutter={[24, 24]}>
                    <Col span={8}>
                      {isHolidayCalendarLoading ? (
                        <div style={{ padding: "10px" }}>
                          <Skeleton />
                        </div>
                      ) : (
                        <CustomHolidayCalendar
                          style={{ borderRadius: "7px" }}
                          fullscreen={false}
                          //@ts-ignore
                          headerRender={({ value, type, onChange, onTypeChange }) => {
                            const current = moment(value.clone());
                            return (
                              <Row justify="center" style={{ padding: "8px" }}>
                                <span
                                  className="back-arrow"
                                  onClick={() => {
                                    onChange(current.clone().subtract(1, "month"));
                                  }}
                                >
                                  <LeftCircleOutlined />
                                </span>
                                <span
                                  className="month-name"
                                  data-date={current.clone().format("YYYY-MM-DD")}
                                >
                                  {current.clone().format("MMMM YYYY")}
                                </span>
                                <span
                                  className="next-arrow"
                                  onClick={() => {
                                    onChange(current.clone().add(1, "month"));
                                  }}
                                >
                                  <RightCircleOutlined />
                                </span>
                              </Row>
                            );
                          }}
                          dateFullCellRender={(value: moment.Moment) => {
                            const data = holidayCalendar.filter(
                              e => e.date == value.format("YYYY-MM-DD"),
                            );
                            if (!data.length) return <span>{value.format("DD")}</span>;
                            const bgColor = BaseColor;
                            return (
                              <>
                                <Tooltip key={data[0].id} title={data[0].description}>
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setSelectedHolidayCalendar(data[0].date)}
                                  >
                                    <Avatar
                                      style={{
                                        backgroundColor: bgColor,
                                      }}
                                    >
                                      {value.format("DD")}
                                    </Avatar>
                                  </span>
                                </Tooltip>
                              </>
                            );
                          }}
                        />
                      )}
                    </Col>
                    <Col span={16}>
                      {!!selectedHolidayCalendar ? (
                        <>
                          <Row gutter={[16, 16]}>
                            <Col style={{ paddingTop: "8px" }}>
                              <span
                                onClick={() => setSelectedHolidayCalendar(undefined)}
                                style={{ cursor: "pointer", color: BaseColor }}
                              >
                                <LeftOutlined />
                              </span>
                            </Col>
                            <Col>
                              <UITitle level={4} color={BaseColor}>
                                {getHolidayByDate(selectedHolidayCalendar)?.description}
                              </UITitle>
                            </Col>
                          </Row>
                          <Row gutter={[16, 16]} style={{ marginBottom: "18px" }}>
                            <Col>
                              <UITitle level={4}>Periodo: </UITitle>
                              <UIText>
                                {!!getHolidayByDate(selectedHolidayCalendar)?.date_from
                                  ? moment(
                                      getHolidayByDate(selectedHolidayCalendar)?.date_from,
                                    ).format("DD/MM/YYYY") +
                                    " - " +
                                    moment(
                                      getHolidayByDate(selectedHolidayCalendar)?.date_to,
                                    ).format("DD/MM/YYYY")
                                  : moment(getHolidayByDate(selectedHolidayCalendar)?.date).format(
                                      "DD/MM/YYYY",
                                    )}
                              </UIText>
                            </Col>
                          </Row>
                          <Row gutter={[16, 16]} style={{ marginBottom: "18px" }}>
                            <Col>
                              <UITitle level={4}>Ricorsivo: </UITitle>
                              <UIText>
                                {!!getHolidayByDate(selectedHolidayCalendar)?.ricorsivo
                                  ? "Si"
                                  : "No"}
                              </UIText>
                            </Col>
                          </Row>
                          <Row gutter={[16, 16]} style={{ marginBottom: "18px" }}>
                            <Col>
                              <UITitle level={4}>Sedi: </UITitle>
                              <UIText>
                                {getHolidayByDate(selectedHolidayCalendar)
                                  ?.offices?.map(e => offices.data.find(el => el.id == e)?.name)
                                  .join(", ")
                                  .toString()}
                              </UIText>
                            </Col>
                          </Row>
                          <Row gutter={[16, 16]} style={{ marginBottom: "18px" }}>
                            <Col>
                              <UIButton
                                onClick={() =>
                                  onRemoveHoliday(getHolidayByDate(selectedHolidayCalendar)?.date)
                                }
                                style={{
                                  borderRadius: "7px",
                                  backgroundColor: "#e00102",
                                  borderColor: "#e00102",
                                  color: "white",
                                }}
                              >
                                Elimina{" "}
                                {!!getHolidayByDate(selectedHolidayCalendar)?.date_from
                                  ? "Periodo"
                                  : "Festività"}
                              </UIButton>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row>
                            <UITitle level={4} color={BaseColor}>
                              Aggiungi festività
                            </UITitle>
                          </Row>
                          <Form layout="vertical" form={form} onFinish={handleSaveHolidays}>
                            <Row gutter={[16, 16]}>
                              <Col span={24}>
                                <Row gutter={[16, 16]}>
                                  <Col span={12}>
                                    <Form.Item
                                      name="description"
                                      label="Descrizione"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Inserisci il nome della festività",
                                        },
                                      ]}
                                    >
                                      <UIInput />
                                    </Form.Item>
                                  </Col>
                                  <Col span={12}>
                                    <Form.Item
                                      name="is_recurrent"
                                      label="E' ricorrente?"
                                      valuePropName="checked"
                                      rules={[{ required: false, message: "Si ripete ogni anno?" }]}
                                    >
                                      <StyledCheckbox />
                                    </Form.Item>
                                  </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                  <Col span={12}>
                                    <Form.Item
                                      name="date"
                                      label="Periodo"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleziona il periodo della festività",
                                        },
                                      ]}
                                    >
                                      <CustomRangePicker
                                        //@ts-ignore
                                        showTime={false}
                                        style={{ width: "100%" }}
                                        format={"DD/MM/YYYY"}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col span={12}>
                                    <Form.Item
                                      name="office_ids"
                                      label="Sedi"
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Seleziona le sedi per cui è valida la festività",
                                        },
                                      ]}
                                    >
                                      <UISelect
                                        mode="multiple"
                                        placeholder="Seleziona le sedi"
                                        style={{ minHeight: "60px" }}
                                      >
                                        <UISelect.Option key="all" value={"all"}>
                                          Tutte
                                        </UISelect.Option>
                                        {offices.data.map(e => (
                                          <UISelect.Option key={e.id} value={e.id}>
                                            {e.name}
                                          </UISelect.Option>
                                        ))}
                                      </UISelect>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row justify="end">
                              <Col>
                                <Form.Item>
                                  <UIButton
                                    type="primary"
                                    htmlType="submit"
                                    loading={isHolidayCalendarLoading}
                                  >
                                    Aggiungi
                                  </UIButton>
                                </Form.Item>
                              </Col>
                            </Row>
                          </Form>
                        </>
                      )}
                    </Col>
                  </Row>
                </UICard>
              </Col>
            )}
          </Row>
        </UITransition>
      )}
      {!!reportData ? (
        <UICard>
          <Row justify="start" style={{ marginBottom: "15px" }}>
            <Col style={{ color: BaseColor, cursor: "pointer", fontSize: "17px" }} onClick={goBack}>
              <LeftCircleOutlined /> Nuovo Report{" "}
            </Col>
          </Row>

          <Row justify="space-between" align="middle" gutter={[16, 16]} style={{ marginBottom: "16px" }}>
            <Col>
              <UIInput
                value={currentQuery}
                onChange={e => setQuery(e.target.value)}
                suffix={isQueryLoading ? <LoadingOutlined /> : null}
                placeholder={"Cerca Dipendente"}
                allowClear
                prefix={<SearchOutlined style={{ marginRight: "5px", color: "#d9d9d9" }} />}
              />
            </Col>
            <Col style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
              <ReportFilters
                hideEmptyRows={hideEmptyRows}
                onHideEmptyRowsChange={setHideEmptyRows}
                onlyWithAnomalies={onlyWithAnomalies}
                onOnlyWithAnomaliesChange={setOnlyWithAnomalies}
                employeesWithAnomalies={usersWithAnomalies.size}
              />
              <UIButton type="primary" onClick={handlePrint}>
                <PrinterOutlined /> Stampa
              </UIButton>
            </Col>
          </Row>

          <ReportScrollProvider>
            <span ref={componentRef}>
              {reportPeriod && (
                <ReportPeriodInfo
                  from={reportPeriod.from}
                  to={reportPeriod.to}
                  employees={Object.keys(reportData).length}
                  visibleEmployees={reportDataFiltered ? reportDataFiltered.length : undefined}
                />
              )}

              {selectedOffice ? getOfficeSelectedInfo() : <></>}

              <ReportLegend
                showMonthlyTotals={
                  !!reportPeriod && !reportPeriod.from.isSame(reportPeriod.to, "month")
                }
              />

              {/* se l'app ha un header fisso, passa la sua altezza: es. stickyTop={64} */}
              <ReportScrollNav stickyTop={0} />

              {reportDataFiltered && reportDataFiltered.length === 0 ? (
                <ReportEmptyResult
                  onReset={() => {
                    setQuery("");
                    setOnlyWithAnomalies(false);
                  }}
                />
              ) : (
                reportDataFiltered && (
                  <ReportViewOptionsProvider hideEmptyRows={hideEmptyRows}>
                    <LazyList>
                      {reportDataFiltered.map(value => (
                        <UserRow key={value.user.id} dataRow={value} />
                      ))}
                    </LazyList>
                  </ReportViewOptionsProvider>
                )
              )}
            </span>
          </ReportScrollProvider>
        </UICard>
        ) : (
        <>
          <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
            {canViewPresenze && (
              <Col lg={12} xs={24}>
                <UICard>
                  <Row>
                    <UITitle color={BaseColor} level={4}>
                      Report Presenze
                    </UITitle>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <Row style={{justifyContent: "space-between"}}>
                        <Col>
                          <Row>
                            <Col span={24}>
                              <UITitle level={5}>Seleziona un periodo</UITitle>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <CustomRangePicker
                                //@ts-ignore
                                onChange={changeDates}
                                format="DD/MM/YYYY"
                                clearIcon={false}
                                value={[dateFrom, dateTo]}
                              />
                            </Col>
                          </Row>

                          <Row style={{ marginTop: "15px" }}>
                            <Col span={24}>
                              <UITitle level={5}>Seleziona una sede</UITitle>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={24}>
                              <UISelect
                                style={{width: "100%"}}
                                allowClear
                                showSearch
                                value={selectedOffice}
                                placeholder={"Nessuna selezione"}
                                //@ts-ignore
                                onChange={value => setSelectedOffice(value)}
                                filterOption={(input, option) =>
                                  ((option!.children as unknown) as string)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {offices.data.map(e => (
                                  <Option key={e.id} value={e.id}>
                                    {e.name}
                                  </Option>
                                ))}
                              </UISelect>
                            </Col>
                          </Row>
                        </Col>

                        <Col>
                          <Row style={{justifyContent: "end", marginTop: "15px"}}>
                            <Col style={{
                                backgroundColor: "#F1F2F5", 
                                padding: "8px", 
                                borderRadius: "7px"
                              }}>
                              <Row>
                                <Col style={{marginRight: "5px", cursor: "pointer"}}>
                                  <Tooltip  title="Se attivo, verranno mostrati gli errori in caso di anomalie">
                                    <InfoCircleFilled />
                                  </Tooltip>
                                </Col>
                                <span><b>Visualizza anomalie</b></span>
                              </Row>

                              <Row style={{marginBottom: "8px"}}>
                                <Switch 
                                  checkedChildren="SI"
                                  unCheckedChildren="NO"
                                  checked={forceAnomalies}
                                  onChange={(value) => {setForceAnomalies(value)}}
                                />
                              </Row>

                              <Row style={{marginBottom: "4px", padding: "0 8px 0 8px", justifyContent: "center"}}>
                                <span style={{color: forceAnomalies ? "#B5B5B8" : "#242425", fontSize: "12px"}}><b>Quali anomalie vuoi visualizzare?</b></span>
                              </Row>
                            
                              <Row>
                                <UICheckbox 
                                  checked={filterAnomalyTimebankNotApproved}
                                  disabled={forceAnomalies}
                                  onChange={(value) => {setFilterAnomalyTimebankNotApproved(value.target.checked)}}>
                                    Presenza non Approvata
                                </UICheckbox>
                              </Row>
                              
                              <Row>
                                <UICheckbox 
                                  checked={filterAnomalyTurnoNonProgrammato}
                                  disabled={forceAnomalies}
                                  onChange={(value) => {setFilterAnomalyTurnoNonProgrammato(value.target.checked)}}>
                                  Turno non programmato
                                  </UICheckbox>
                              </Row>

                              <Row>
                                <UICheckbox 
                                  checked={filterAnomalyMancataTimbratura}
                                  disabled={forceAnomalies}
                                  onChange={(value) => {setFilterAnomalyMancataTimbratura(value.target.checked)}}>
                                  Mancata Timbratura
                                </UICheckbox>
                              </Row>
                            </Col>
                          </Row>
                        </Col>

                      </Row>

                      <Row style={{alignItems: "baseline"}}>
                        <Col style={{marginRight: "5px", cursor: "pointer"}}>
                          <Tooltip  title="Se attivo, le ore di straordinario verranno accorpate alle ore di lavoro ordinario">
                          <InfoCircleFilled />
                          </Tooltip>
                        </Col>
                        <UITitle level={5}>Straordinario accorpato S/N</UITitle>
                      </Row>
                      <Row> 
                        <Switch 
                          checkedChildren="SI"
                          unCheckedChildren="NO"
                          checked={filterStraordinarioIntoOrdinario}
                          onChange={(value) => {setFilterStraordinarioIntoOrdinario(value)}}
                        />    
                      </Row>

                      <Row style={{ marginTop: "15px" }}>
                        <Col span={24}>
                          <UITitle level={5}>Seleziona utenti</UITitle>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <CustomCascader
                            style={{ width: "100%" }}
                            loading={!!isUserLoading}
                            notFoundContent={
                              isUserLoading ? (
                                <Spin size="small" />
                              ) : (
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                              )
                            }
                            showSearch
                            options={options}
                            //@ts-ignore
                            onChange={onChangeFilters}
                            multiple
                            value={selectedValues}
                            placeholder={
                              <span>
                                <SearchOutlined style={{ marginRight: "5px" }} /> - Tutti -
                              </span>
                            }
                          />
                        </Col>
                      </Row>
                      <Row style={{ marginTop: "15px" }}>
                        <Col style={{ marginRight: "10px", marginBottom: "3px" }}>
                          <UIButton loading={isShowLoading} type="primary" onClick={exportPlain}>
                            <EyeOutlined /> Visualizza
                          </UIButton>
                        </Col>
                        <Col style={{ marginRight: "10px", marginBottom: "3px" }}>
                          <UIButton
                            onClick={exportCsv}
                            loading={isCSVLoading}
                            style={{
                              backgroundColor: "#4b8389",
                              borderColor: "#07512a",
                              color: "#fff",
                            }}
                            hoverBgColor="#62a3aa!important"
                          >
                            <ContainerOutlined /> Esporta CSV
                          </UIButton>
                        </Col>
                        {canExportXls && (
                          <Col style={{ marginRight: "10px", marginBottom: "3px" }}>
                            <UIButton
                              onClick={exportXls}
                              loading={isXlsLoading}
                              style={{
                                backgroundColor: "#5c894b",
                                borderColor: "#1e5107",
                                color: "#fff",
                              }}
                              hoverBgColor="#7f9d74!important"
                            >
                              <FileExcelOutlined /> Esporta XLS
                            </UIButton>
                          </Col>
                        )}
                        {canExportTS && (
                          <Col style={{ marginRight: "10px", marginBottom: "3px" }}>
                            <UIButton
                              onClick={exportTeamSystem}
                              loading={isTeamSystemLoading}
                              style={{
                                backgroundImage: "linear-gradient(to right ,#17509e, #e95756)",
                                borderColor: "#001d70",
                                color: "#fff",
                              }}
                              hoverBgColor="#0245a2!important"
                            >
                              <DeliveredProcedureOutlined /> Esporta Tracciato TS
                            </UIButton>
                          </Col>
                        )}
                        {canExportZucchetti && (
                          <Col style={{ marginRight: "10px", marginBottom: "3px" }}>
                            <UIButton
                              onClick={exportZucchetti}
                              loading={isZucchettiLoading}
                              style={{
                                backgroundColor: "#0072bc",
                                borderColor: "#001d70",
                                color: "#fff",
                              }}
                              hoverBgColor="#0245a2!important"
                            >
                              <SwapOutlined /> Esporta per Zucchetti
                            </UIButton>
                          </Col>
                        )}
                        {canExportJOB && (
                          <Col style={{ marginRight: "10px", marginBottom: "3px" }}>
                            <UIButton
                              onClick={exportJOB}
                              loading={isJOBLoading}
                              style={{
                                backgroundColor: "#e95756",
                                borderColor: "#001d70",
                                color: "#fff",
                              }}
                              hoverBgColor="#ED7877!important">
                              <DeliveredProcedureOutlined /> Esporta Tracciato JOB
                            </UIButton>
                          </Col>
                        )}
                        <MissingUsersModal
                          isModalVisible={showUtentiMancantiModal}
                          closeModal={() => setUtentiMancanti([])}
                          missingUsers={utentiMancanti}
                        />
                      </Row>
                      {!!percentage && (
                        <Row>
                          <Col span={24}>
                            <ProgressCustom
                              percent={parseInt(percentage)}
                              strokeColor={BaseColor}
                              style={{ width: "100%", marginTop: "15px" }}
                              status="active"
                            />
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </UICard>
              </Col>
            )}
            {canExportProd && (
              <Col lg={12} xs={24}>
                <UICard>
                  <Row>
                    <UITitle color={BaseColor} level={4}>
                      Report Produttività
                    </UITitle>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona un periodo</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <CustomRangePicker
                        //@ts-ignore
                        onChange={changeDatesProd}
                        format="DD/MM/YYYY"
                        clearIcon={false}
                        value={[dateFromProd, dateToProd]}
                      />
                    </Col>
                  </Row>
                  <Row style={{marginTop: "15px", alignItems: "baseline"}}>
                    <Col style={{marginRight: "5px", cursor: "pointer"}}>
                      <Tooltip  title="Se attivo, verranno mostrati in aggiunta anche gli utenti Disabilitati">
                      <InfoCircleFilled />
                      </Tooltip>
                    </Col>
                    <UITitle level={5}>Mostrare utenti Disabilitati</UITitle>
                  </Row>
                  <Row> 
                    <Switch 
                      checkedChildren="SI"
                      unCheckedChildren="NO"
                      checked={checkDisabledUsers}
                      onChange={(value) => {setCheckDisabledUsers(value)}}
                    />    
                  </Row>
                  <Row style={{ marginTop: "15px" }}>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona utenti</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <CustomCascader
                        style={{ width: "100%" }}
                        loading={!!isUserLoading}
                        notFoundContent={
                          isUserLoading ? (
                            <Spin size="small" />
                          ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                          )
                        }
                        showSearch
                        options={optionsUsersWithDisabled}
                        //@ts-ignore
                        onChange={onChangeFiltersProd}
                        multiple
                        value={selectedValuesProd}
                        placeholder={
                          <span>
                            <SearchOutlined style={{ marginRight: "5px" }} /> - Tutti -
                          </span>
                        }
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "15px" }}>
                    <Col>
                      <UIButton
                        onClick={exportCsvProd}
                        loading={isCSVProdLoading}
                        style={{
                          backgroundColor: "#4b8389",
                          borderColor: "#07512a",
                          color: "#fff",
                        }}
                        hoverBgColor="#62a3aa!important"
                      >
                        <FileExcelOutlined /> Esporta CSV
                      </UIButton>
                    </Col>
                    {canExportXlsProduttivita && (
                      <Col style={{ marginLeft: "10px", marginBottom: "3px" }}>
                        <UIButton
                          onClick={exportXlsProd}
                          loading={isXlsProdLoading}
                          style={{
                            backgroundColor: "#5c894b",
                            borderColor: "#1e5107",
                            color: "#fff",
                          }}
                          hoverBgColor="#7f9d74!important"
                        >
                          <FileExcelOutlined /> Esporta XLS
                        </UIButton>
                      </Col>
                    )}
                  </Row>
                  {!!percentageProd && (
                    <Row>
                      <Col span={24}>
                        <ProgressCustom
                          percent={parseInt(percentageProd)}
                          strokeColor={BaseColor}
                          style={{ width: "100%", marginTop: "15px" }}
                          status="active"
                        />
                      </Col>
                    </Row>
                  )}
                </UICard>
              </Col>
            )}
          </Row>

          <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
            {canViewAnomalie && (
              <Col lg={8} xs={24}>
                <UICard>
                  <Row>
                    <UITitle color={BaseColor} level={4}>
                      Report Anomalie
                    </UITitle>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona un periodo</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <CustomRangePicker
                        //@ts-ignore
                        onChange={changeDatesAnomalie}
                        format="DD/MM/YYYY"
                        clearIcon={false}
                        value={[dateFromAnomalie, dateToAnomalie]}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "15px" }}>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona utenti</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <CustomCascader
                        style={{ width: "100%" }}
                        loading={!!isUserLoading}
                        notFoundContent={
                          isUserLoading ? (
                            <Spin size="small" />
                          ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                          )
                        }
                        showSearch
                        options={options}
                        //@ts-ignore
                        onChange={onChangeFiltersAnomalie}
                        multiple
                        value={selectedValuesAnomalie}
                        placeholder={
                          <span>
                            <SearchOutlined style={{ marginRight: "5px" }} /> - Tutti -
                          </span>
                        }
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "15px" }}>
                    <Col>
                      <UIButton onClick={exportAnomalie} loading={isAnomalieLoading} type="primary">
                        Esporta Anomalie
                      </UIButton>
                    </Col>
                  </Row>
                </UICard>
              </Col>
            )}
            {canViewFerie && (
              <Col lg={8} xs={24}>
                <UICard>
                  <Row>
                    <UITitle color={BaseColor} level={4}>
                      Report Ferie
                    </UITitle>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona un periodo</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <CustomRangePicker
                        //@ts-ignore
                        onChange={changeDatesFerie}
                        format="DD/MM/YYYY"
                        clearIcon={false}
                        value={[dateFromFerie, dateToFerie]}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "15px" }}>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona utenti</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <CustomCascader
                        style={{ width: "100%" }}
                        loading={!!isUserLoading}
                        notFoundContent={
                          isUserLoading ? (
                            <Spin size="small" />
                          ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                          )
                        }
                        showSearch
                        options={options}
                        //@ts-ignore
                        onChange={onChangeFiltersFerie}
                        multiple
                        value={selectedValuesFerie}
                        placeholder={
                          <span>
                            <SearchOutlined style={{ marginRight: "5px" }} /> - Tutti -
                          </span>
                        }
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "15px" }}>
                    <Col>
                      <UIButton
                        onClick={exportFerie}
                        loading={isFerieLoading}
                        style={{
                          backgroundColor: "rgb(233 171 79)",
                          borderColor: "#906c36",
                          color: "#fff",
                        }}
                        hoverBgColor="#ebba71!important"
                      >
                        Esporta Ferie
                      </UIButton>
                    </Col>
                  </Row>
                </UICard>
              </Col>
            )}
            {canViewMalattie && (
              <Col lg={8} xs={24}>
                <UICard>
                  <Row>
                    <UITitle color={BaseColor} level={4}>
                      Report Malattie
                    </UITitle>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona un periodo</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <CustomRangePicker
                        //@ts-ignore
                        onChange={changeDatesMalattie}
                        format="DD/MM/YYYY"
                        clearIcon={false}
                        value={[dateFromMalattie, dateToMalattie]}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "15px" }}>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona utenti</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <CustomCascader
                        style={{ width: "100%" }}
                        loading={!!isUserLoading}
                        notFoundContent={
                          isUserLoading ? (
                            <Spin size="small" />
                          ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                          )
                        }
                        showSearch
                        options={options}
                        //@ts-ignore
                        onChange={onChangeFiltersMalattie}
                        multiple
                        value={selectedValuesMalattie}
                        placeholder={
                          <span>
                            <SearchOutlined style={{ marginRight: "5px" }} /> - Tutti -
                          </span>
                        }
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "15px" }}>
                    <Col>
                      <UIButton
                        onClick={exportMalattie}
                        loading={isMalattieLoading}
                        //@ts-ignore
                        type="danger"
                      >
                        Esporta Malattie
                      </UIButton>
                    </Col>
                  </Row>
                </UICard>
              </Col>
            )}
            {canViewReportGiustificativi && (
            <Col lg={8} xs={24}>
              <UICard>
                <Row>
                  <UITitle color={BaseColor} level={4}>
                    Report Giustificativi
                  </UITitle>
                </Row>
                <Row>
                  <Col span={24}>
                    <UITitle level={5}>Tipologia Richiesta</UITitle>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="justificative_type_id"
                      rules={[{ required: true, message: "Seleziona la tipologia della richiesta" }]}
                    >
                      <UISelect onChange={onChangeJustificativeTypeId}>
                        <Option value={TJustificativeType.FERIE_ANNUALE} key={TJustificativeType.FERIE_ANNUALE}>
                          Ferie Annuali
                        </Option>
                        {justificatives.data.map(justificative => (
                          <Option value={justificative.id} key={justificative.id}>
                            {justificative.name}
                          </Option>
                        ))}
                      </UISelect>
                    </Form.Item>
                  </Col>
                </Row>
                {justificativeTypeId === TJustificativeType.FERIE_ANNUALE ? 
                <>
                  <Row>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona l'anno</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <DatePicker
                        onChange={handleYearChange}
                        picker="year"
                        clearIcon={false}
                        defaultValue={moment()}
                        disabledDate={(current) => current && current.isAfter(moment().endOf('year'))}
                      />
                    </Col>
                  </Row>
                </>
                : 
                <>
                  <Row>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona un periodo</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <CustomRangePicker
                        //@ts-ignore
                        onChange={changeDatesReportGiustificativi}
                        format="DD/MM/YYYY"
                        clearIcon={false}
                        value={[dateFromReportGiustificativi, dateToReportGiustificativi]}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "15px" }}>
                    <Col span={24}>
                      <UITitle level={5}>Seleziona utenti</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <CustomCascader
                        style={{ width: "100%" }}
                        loading={!!isUserLoading}
                        notFoundContent={
                          isUserLoading ? (
                            <Spin size="small" />
                          ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                          )
                        }
                        showSearch
                        options={options}
                        //@ts-ignore
                        onChange={onChangeFiltersReportGiustificativi}
                        multiple
                        value={selectedValuesReportGiustificativi}
                        placeholder={
                          <span>
                            <SearchOutlined style={{ marginRight: "5px" }} /> - Tutti -
                          </span>
                        }
                      />
                    </Col>
                  </Row>
                </>}
                {/* Entra qua dentro solo nel caso Malattia (id: 2) */}
                {justificativeTypeId == TJustificativeType.MALATTIA ? 
                <>
                  <Row style={{ marginTop: "15px" }}>
                    <Col span={24}>
                      <UITitle level={5}>Analitico</UITitle>
                    </Col>
                  </Row>
                  <Row>
                    <Form.Item name="report_malattia_is_analitico">
                      <Switch 
                        checkedChildren="SI"
                        unCheckedChildren="NO"
                        onChange={(value) => {setReportMalattiaIsAnalitico(value)}}
                      />
                    </Form.Item>
                  </Row>
                </>
                : <></>}
                <Row style={{ marginTop: "15px" }}>
                  <Col>
                    <UIButton
                      onClick={exportReportGiustificativi}
                      loading={isReportGiustificativiLoading}
                      //@ts-ignore
                      type="danger"
                    >
                      Esporta Report
                    </UIButton>
                  </Col>
                </Row>
              </UICard>
            </Col>
            )}
          </Row>
          <Row gutter={[16, 16]}>
            {canViewAnalytics && (
              <>
                <Col lg={8} xs={24}>
                  <UICard>
                    <Row justify="space-between">
                      <Col>
                        <UITitle color={BaseColor} level={4}>
                          Richieste
                        </UITitle>
                      </Col>
                      <Col>
                        <UIDatePicker
                          onChange={(value: moment.Moment | null): void => setMonthRichieste(value)}
                          value={monthRichieste}
                          picker="month"
                          format="MMMM"
                          allowClear={false}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <RequestStatistics date={monthRichieste} />
                      </Col>
                    </Row>
                  </UICard>
                </Col>

                <Col lg={8} xs={24}>
                  <UICard>
                    <Row justify="space-between">
                      <Col>
                        <UITitle color={BaseColor} level={4}>
                          Turni
                        </UITitle>
                      </Col>
                      <Col>
                        <UIDatePicker
                          onChange={(value: moment.Moment | null): void => setMonthTurni(value)}
                          value={monthTurni}
                          picker="month"
                          format="MMMM"
                          allowClear={false}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <ShiftStatistics date={monthTurni} />
                      </Col>
                    </Row>
                  </UICard>
                </Col>
                <Col lg={8} xs={24}>
                  <UICard>
                    <Row justify="space-between">
                      <Col>
                        <UITitle color={BaseColor} level={4}>
                          Presenze
                        </UITitle>
                      </Col>
                      <Col>
                        <UIDatePicker
                          onChange={(value: moment.Moment | null): void => setMonthPresenze(value)}
                          value={monthPresenze}
                          picker="month"
                          format="MMMM"
                          allowClear={false}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <PresenceStatistics date={monthPresenze} />
                      </Col>
                    </Row>
                  </UICard>
                </Col>
              </>
            )}
          </Row>
        </>
      )}
    </UITransition>
  );
};

const CustomCascader = styled(Cascader)`
  .ant-select-selector {
    border-radius: 7px !important;
  }
`;

const ProgressCustom = styled(Progress)`
  font-size: 16px !important;
  .ant-progress-inner {
    height: 11px;
  }

  .ant-progress-bg {
    height: 11px !important;
  }
`;

const CustomMonthCalendar = styled(Calendar)`
  .back-arrow {
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    color: ${BaseColor};
  }

  .next-arrow {
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    color: ${BaseColor};
  }

  .year-name {
    font-size: 17px;
    font-weight: bold;
    margin: 0px 20px;
    text-transform: capitalize;
    color: ${BaseColor};
  }
  .ant-picker-calendar-mini {
    border-radius: 7px !important;
  }
  .ant-picker-calendar-mini .ant-picker-panel {
    border-radius: 0 0 7px 7px !important;
  }
  .ant-picker-calendar .ant-picker-panel .ant-picker-body {
    padding: 8px 8px !important;
  }
`;

const CustomHolidayCalendar = styled(CustomCalendar)`
  .ant-picker-date-panel {
    margin-top: 8px !important;
  }
`;

const StyledCheckbox = styled(UICheckbox)`
  .ant-checkbox-inner {
    width: 32px;
    height: 32px;
    border-radius: 7px;
  }
  .ant-checkbox-inner:after {
    left: 10px;
  }
  .ant-checkbox {
    font-size: 0px;
  }
`;

const CustomDatePicker = styled(DatePicker)`
  border-radius: 7px;
  margin: 0px 15px;
  input {
    text-transform: capitalize;
  }
`;